export const taxInvoiceLabels: { [key: string]: string } = {
  USD: 'Receipt',
}
